import React from 'react';
import * as S from './../styles/styles'; 
import { motion } from "framer-motion";
import { FaBehance, FaRegStar } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import ImgAgua from './../styles/agua.png'
import imgBoina from './../styles/boinaazul.png'
import imgPintar from './../styles/pintar.png'
import imgMarca from './../styles/produtoMarca.png'
import imgProdutos from './../styles/produtos.png'
import imgStand from './../styles/stand.png'
import imgColmeias from './../styles/colmeias.png'
import imgStand2 from './../styles/stand2.png'
import imgAgP from './../styles/aguaprodutos.png'

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 } 
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1 }
};


const bgStyle = (img) => ({
  backgroundImage: `url(${img})`,
  backgroundSize: "cover",
  backgroundPosition: "center"
});

export default function Gallery() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <S.App>

      <S.Header> 
        
        {!isMobile && (
          <>
           <Link to="/home" viewTransition style={{ textDecoration: 'none', color: 'black' }}><span>Home</span></Link>
           <Link to="/about" viewTransition style={{ textDecoration: 'none', color: 'black' }}><span>About</span></Link>
           <Link to="/gallery" viewTransition style={{ textDecoration: 'none', color: 'black' }}><span>Gallery</span></Link>
          </>
        )}

        <S.SymbolGroup>
          <a href="https://www.linkedin.com/in/mariasouza-dan/" target="_blank" rel="noreferrer">
            <S.SymbolLinkedin><FaLinkedinIn/></S.SymbolLinkedin>
          </a>  
          <a href="https://www.behance.net/Dandelious" target="_blank" rel="noreferrer">
            <S.SymbolBehance><FaBehance/></S.SymbolBehance>
          </a>
        </S.SymbolGroup>

      </S.Header>

      <S.HeaderDivider />

      <S.MainContent>
        <S.BentoGrid 
          as={motion.div} 
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          style={{ overflow: "visible" }} // 🔥 evita corte no hover
        >
      
          <S.BentoItem 
            isLarge 
            variants={itemVariants}
            whileHover={{ scale: 1.6 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            style={bgStyle(imgMarca)}
          />

          <S.BentoItem 
            isLarge 
            variants={itemVariants}  
            whileHover={{ scale: 1.6, borderRadius: "20px" }} 
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            style={bgStyle(ImgAgua)}
          />
              
          <S.BentoItem 
            variants={itemVariants}  
            whileHover={{ scale: 1.6 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            style={bgStyle(imgBoina)}
          />

          <S.BentoItem 
            isWide 
            variants={itemVariants}  
            whileHover={{ scale: 2.1, borderRadius: "20px" }} 
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            style={bgStyle(imgColmeias)}
          />
          
          <S.BentoItem 
            variants={itemVariants} 
            whileHover={{ scale: 1.6 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            style={bgStyle(imgPintar)}
          />

          <S.BentoItem 
            isLarge
            variants={itemVariants} 
            whileHover={{ scale: 2 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            style={bgStyle(imgStand)}
          />

          <S.BentoItem 
            isWide
            variants={itemVariants} 
            whileHover={{ scale: 2 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            style={bgStyle(imgStand2)}
          />

          <S.BentoItem 
            isWide
            variants={itemVariants} 
            whileHover={{ scale: 2 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            style={bgStyle(imgAgP)}
          />

        </S.BentoGrid>
      </S.MainContent>
      <S.Footer>
              {!isMobile && (
                <S.FooterText style={{ position: 'relative', marginTop: '20px', fontSize: '40px' }}>
                   Dandelious Designer <FaRegStar />
                </S.FooterText>
              )}
              <S.BarraVertical />
              <S.FooterNav>
                <Link viewTransition to="/about"><span>About</span></Link>
                <Link viewTransition to="/home"><span>Home</span></Link>
              </S.FooterNav>
              <S.ContactBox>
                <S.ContactHeader>Contact</S.ContactHeader>
                <S.ContactBody>dandelious.design@gmail.com</S.ContactBody>
              </S.ContactBox>
        </S.Footer>
    </S.App>
  );
}